import ExportIcon from "@material-ui/icons/GetApp";
import { AppList } from "components/list/AppList";
import { AppReferenceManyField } from "components/list/AppReferenceManyField";
import { YesNoField } from "components/fields/YesNoField";
import { OrderImportStatusColors, OrderImportStatusNames } from "entities/OrderImportStatus";
import { OrderStatus } from "entities/OrderStatus";
import React from "react";
import {
	Button,
	ChipField,
	Datagrid,
	ReferenceField,
	SingleFieldList,
	TextField,
} from "react-admin";
import { isNullUndEmpty } from "utils/general";
import { downloadBlob } from "utils/download";

import { DateTimeField } from "../../../components/fields/DateFormatField";
import { SelectEnumField } from "../../../components/fields/SelectEnumField";
import { OrderImportTracksFilters } from "./ListFilters";

const CustomDownloadButton = ({ record, label, href, onClick, renderCondition = () => true }) => {
	if (!(renderCondition && renderCondition(record))) return null;
	return (
		<Button
			label={label}
			variant="outlined"
			color="primary"
			href={typeof href === "function" ? href(record) : href}
			onClick={() => onClick && onClick(record)}
			startIcon={<ExportIcon />}
		/>
	);
};

const anyOrderStatusFilter = { status: Object.values(OrderStatus) };

const RelatedOrdersField = ({ record, source, ...rest }) =>
	record.order_ids.length > 0 ? (
		<AppReferenceManyField
			{...rest}
			reference="orders"
			source={source}
			target="selected_ids"
			filter={anyOrderStatusFilter}
			allowEmpty={true}
			pagination={false}
		>
			<SingleFieldList style={{ display: "block" }}>
				<ChipField source="id" size="small" />
			</SingleFieldList>
		</AppReferenceManyField>
	) : null;

const TrucksTraffic = ({ permissions, ...props }) => {
	const downloadDataJson = (record) => {
		const jsonString = JSON.stringify(record.data, null, 2);
		const blob = new Blob([jsonString], { type: "application/json" });
		downloadBlob(blob, `order_import_${record.id}_data.json`);
	};

	const makeFilePreviewHref = (record) => record.preview_file_src;
	const inputFileRenderCondition = (record) => !isNullUndEmpty(record.preview_file_src);
	const dataRenderCondition = (record) => record.data?.length > 0;

	const rowStyle = (record) => ({
		backgroundColor: OrderImportStatusColors[record.status],
	});

	return (
		<AppList
			{...props}
			exporter={false}
			bulkActionButtons={false}
			sort={{ field: "created_at", order: "DESC" }}
			filters={<OrderImportTracksFilters />}
		>
			<Datagrid rowStyle={rowStyle}>
				<TextField source="id" />
				<SelectEnumField
					source="status"
					sortable={false}
					enumObj={OrderImportStatusNames}
					translate={false}
					reverse
				/>

				<DateTimeField source="created_at" withLocalTimeZone />

				<ReferenceField source="created_by" reference="users" link={false}>
					<TextField source="first_name" />
				</ReferenceField>

				<RelatedOrdersField source="order_ids" sortable={false} />

				<CustomDownloadButton
					label="resources.order-import-tracks.fields.import_file_button"
					href={makeFilePreviewHref}
					renderCondition={inputFileRenderCondition}
				/>
				<CustomDownloadButton
					label="resources.order-import-tracks.fields.import_data_button"
					onClick={downloadDataJson}
					renderCondition={dataRenderCondition}
				/>
			</Datagrid>
		</AppList>
	);
};

export default TrucksTraffic;
